export default __webpack_public_path__ + "rpl_co_brand_dark.9c13d5a0.svg";